const scrollUp = document.querySelector('.scroll-up');

window.addEventListener('scroll', () => {
	scrollUp.classList.remove('show');
	if (window.scrollY > 500) {
		scrollUp.classList.add('show');
	}
})

scrollUp.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});
})
